import { CkeckColor } from "hooks/layout-hooks"
import { useEffect, useState } from "react"
import { LayoutStore } from "store/layout-store"
import { ConvertMiladiToJalali, methodCheckIsActiveFields } from "utils/layout-utils"


export const Statistics = ({ metrics }: any) => {
    const [maxSymbol, setMaxSymbol] = useState<any>('')
    const [minSymbol, setMinSymbol] = useState<any>('')

    useEffect(() => {
        if (metrics?.numberOfTradePerSymbol) {
            let minKey = Object.keys(metrics?.numberOfTradePerSymbol)[0];
            let minValue: any = Object.values(metrics?.numberOfTradePerSymbol)[0];
            let maxKey = '';
            let maxValue = 0;
            let item: any;
            for (item of Object.entries(metrics?.numberOfTradePerSymbol)) {
                if (item[1] < minValue) {
                    minValue = item[1]
                    minKey = item[0]
                }
                else if (item[1] >= maxValue) {
                    maxValue = item[1]
                    maxKey = item[0]
                }
            }
            setMaxSymbol(maxKey)
            setMinSymbol(minKey)
        }
    }, [metrics])

    return (
        <>
            <div className="md:w-[35%] w-full md:pl-2 pl-0">
                <div className="flex flex-col w-full px-3 py-4 rounded-md bg-trade-50">
                    {methodCheckIsActiveFields('trades') &&
                        <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>تعداد معاملات</span>
                            <span>{metrics?.trades}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('wonTrades') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>معاملات موفق</span>
                            <span>{metrics?.wonTrades}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('lostTrades') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>معاملات ناموفق</span>
                            <span>{metrics?.lostTrades}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('bestTrade') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>بهترین معامله </span>
                            <span>{ConvertMiladiToJalali(metrics?.bestTradeDate)}</span>
                            <span>{CkeckColor(metrics?.bestTrade , '$')}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('worstTrade') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span> بدترین معامله</span>
                            <span>{ConvertMiladiToJalali(metrics?.worstTradeDate)}</span>
                            <span>{CkeckColor(metrics?.worstTrade , '$')}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('averageWin') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>میانگین سود</span>
                            <span>{CkeckColor(metrics?.averageWin?.toFixed(2) , '$')}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('averageLoss') &&
                        <div className=" w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>میانگین ضرر</span>
                            <span>{CkeckColor(metrics?.averageLoss?.toFixed(2) , '$')}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('averageWinPips') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>میانگین سود پیپ</span>
                            <span>{CkeckColor(metrics?.averageWinPips?.toFixed(2))}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('averageLossPips') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>میانگین ضرر پیپ</span>
                            <span className="text-red-500">{metrics?.averageLossPips?.toFixed(2)}</span>
                        </div>
                    }
                </div>
            </div>

            <div className="md:w-[35%] w-full md:px-1 px-0">
                <div className="w-full px-3 py-4 rounded-md bg-trade-50">
                    {methodCheckIsActiveFields('pips') &&
                        <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>برآیند پیپ معامله شده</span>
                            <span>{CkeckColor(metrics?.pips?.toFixed(2))}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('lots') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>حجم معامله شده (لات)</span>
                            <span>{CkeckColor(metrics?.lots?.toFixed(2))}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('averageTradesTime') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>میانگین زمان معاملات (دقیقه)</span>
                            <span>{metrics?.averageTradesTime?.minutes}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('minimumTradesTime') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>کمترین زمان معاملات (دقیقه)</span>
                            <span>{metrics?.minimumTradesTime?.minutes}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('maximumTradesTime') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>بیشترین زمان معامله (دقیقه)</span>
                            <span>{metrics?.maximumTradesTime?.minutes}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('maxSymbol') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>بیشترین نماد معامله شده</span>
                            <span>{maxSymbol}</span>
                        </div>
                    }
                    {methodCheckIsActiveFields('minSymbol') &&
                        <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                            <span>کمترین نماد معامله شده</span>
                            <span>{minSymbol}</span>
                        </div>
                    }
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بازدهی مورد انتظار</span>
                        <span>———</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>بازدهی مورد انتظار بر اساس پیپ</span>
                        <span>———</span>
                    </div>
                </div>
            </div>


            <div className="md:w-[30%] w-full md:pr-2 pr-0">
                <div className="w-full px-2 py-2 rounded-md bg-trade-50">
                    <div className="w-full h-[40px] bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>{CkeckColor(metrics?.profitFactor?.toFixed(2))}</span>
                        <span>Profit Factor</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>00.00</span>
                        <span>Sharpe Ratio</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>00.00</span>
                        <span>Sartino Ratio</span>
                    </div>
                    <div className="w-full h-[40px] mt-2 bg-trade-25 rounded-md flex items-center justify-between px-2 text-sm text-white">
                        <span>00</span>
                        <span>z Score</span>
                    </div>
                </div>
            </div>
        </>
    )
}